import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './AuthService';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (window.location.href.includes('payment')) {
      return true
    } else {
      if (this.authService.isAuthenticated()) {
        this.router.navigate(['/home/quick-actions']); // Redirect to quick actions if logged in
        return false; // Prevent navigation to login page
      }
    }
    return true; // Allow navigation to login page if not logged in
  }
}
